import styles from '@components/components/CmsComponents/components/CmsTestimonials/CmsTestimonials.module.scss';
import React from 'react';
import {
  Content,
  Heading,
  Slider,
  SliderControl,
  TestimonialCard,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CmsTestimonials = ({
  headingLevel = 4,
  items,
  title,
  subtext,
  hasBackgroundImage,
  containerDimension,
}) => {
  const testimonialSliderSettings = {
    spaceBetween: 40,
    slidesPerView: 1,
    breakpoints: {
      1200: {
        slidesPerView: containerDimension ? 2 : 3,
      },
      768: {
        slidesPerView: containerDimension ? 2 : 2.1,
      },
      400: {
        slidesPerView: containerDimension ? 1 : 1.2,
      },
    },
  };
  return (
    <>
      <div className={styles.contentWrapper}>
        {title && (
          <Heading
            as={getHeadingTag(headingLevel)}
            className={styles.title}
            size="h4"
          >
            {title}
          </Heading>
        )}
        {subtext && (
          <Content noSpacing size="md" withParser>
            {subtext}
          </Content>
        )}
      </div>
      <div
        className={classNames(styles.sliderContainer, {
          [styles.orangeBlue]: hasBackgroundImage,
          [styles.isInContainer]:
            containerDimension && containerDimension !== 'full',
        })}
      >
        <Slider
          {...testimonialSliderSettings}
          isFullWidth={!containerDimension}
        >
          <div className={styles.controlsContainer} data-no-slide>
            <SliderControl className={styles.controlButton} direction="left" />
            <SliderControl className={styles.controlButton} direction="right" />
          </div>
          {items.map(item => (
            <TestimonialCard {...item} key={item.name} />
          ))}
        </Slider>
      </div>
    </>
  );
};

CmsTestimonials.propTypes = {
  hasBackgroundImage: PropTypes.bool,
  headingLevel: PropTypes.number,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      position: PropTypes.string.isRequired,
      zitatText: PropTypes.string.isRequired,
      image: PropTypes.shape({
        title: PropTypes.string,
        src: PropTypes.string,
        srcSet: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      }).isRequired,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          icon: PropTypes.string,
          url: PropTypes.shape({
            target: PropTypes.string,
            url: PropTypes.string,
            title: PropTypes.string,
          }),
        }),
      ),
    }),
  ),
  subtext: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
CmsTestimonials.defaultProps = {
  hasBackgroundImage: true,
  items: [],
};
export default CmsTestimonials;
